import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBg2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 392,
	height: 530,
	viewBox: "0 0 392 530",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_8150_8484)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M369.049 279.959C370.56 266.07 361.983 270.459 351.74 270.443C345.209 273.229 352.623 288.95 352.257 295.223C353.136 298.484 355.215 302.563 359.063 302.983C370.494 303.996 366.772 287.241 369.049 279.959ZM234.049 298.017C232.648 289.606 236.521 276.872 223.539 281.678C219.19 283.572 206.567 278.926 208.048 286.552C209.531 311.268 231.297 341.958 234.049 298.017ZM318.042 272.113C314.334 273.897 303.007 269.823 303.16 276.315C305.31 285.286 307.472 294.255 309.703 303.205C311.793 318.957 333.935 311.696 332.917 298.26C331.039 285.05 337.84 268.488 318.042 272.113ZM403.197 269.418C395.614 269.369 385.38 267.028 389.384 277.974C391.693 288.147 390.931 303.657 402.755 307.69C407.464 308.522 416.274 313.195 417.358 305.672C419.111 297.149 419.264 288.517 418.306 279.923C417.853 266.613 416.627 268.618 403.197 269.418ZM287.331 292.695C286.353 265.318 277.746 277.791 255.951 276.942C249.529 278.736 257.796 293.715 258.036 298.909C264.286 327.552 289.096 320.508 287.331 292.695ZM387.858 252.535C387.856 252.367 387.854 252.199 387.852 252.031C437.451 251.662 424.756 250.832 412.007 209.793C403.158 185.793 344.74 161.742 320.048 163.942C284.891 174.08 249.955 194.8 226.505 223.093C217.528 236.498 207.777 249.457 200.44 263.865C194.529 274.156 228.663 267.563 233.778 266.491C284.659 258.757 336.511 255.407 387.858 252.535ZM296.919 313.748C289.831 324.512 279.4 330.798 266.617 329.203C252.892 330.701 248.624 301.021 243.135 318.849C218.47 356.752 193.88 316.946 195.455 287.238C195.304 285.617 194.458 284.406 192.722 284.611C179.765 282.086 182.437 260.979 187.175 251.907C213.204 207.064 193.075 239.144 157.212 213.347C143.219 204.94 122.845 160.892 155.425 172.946C159.233 194.607 182.41 207.759 200.063 219.681C205.857 223.937 208.745 213.729 212.048 210.441C217.453 202.325 224.631 195.668 231.884 189.289C232.047 186.892 230.196 186.846 229.1 186.187C213.383 176.9 203.594 156.355 211.952 139.658C218.277 133.74 219.97 141.409 220.111 146.428C222.065 159.106 234.129 180.704 248.368 178.19C264.767 167.961 281.422 157.978 299.735 151.527C308.953 148.276 294.369 122.803 295.026 113.757C292.397 103.671 303.628 98.9714 309.193 107.928C316.255 117.822 321.298 128.968 323.868 140.817C325.564 147.097 325.575 147.048 332.039 146.773C352.12 147.569 371.915 154.005 389.469 163.884C407.901 174.066 411.651 108.039 426.791 121.204C442.07 153.633 407.663 169.962 413.632 177.359C424.72 184.582 429.001 196.12 433.532 207.954C445.873 203.946 458.195 202.758 468.992 195.84C472.735 193.331 479.544 188.681 481.471 195.503C490.134 210.742 471.482 215.655 459.622 218.191C423.796 222.188 439.491 216.164 444.286 256.816C447.393 267.377 435.892 262.857 434.174 269.761C433.419 283.491 434.251 297.639 430.683 311.001C424.409 333.905 393.081 326.913 381.346 311.928C379.46 309.56 378.357 309.476 376.555 311.94C369.426 320.657 355.382 321.901 346.761 315.658C335.105 304.664 322.921 347.855 296.919 313.748Z",
				fill: "#79C912",
				fillOpacity: .1
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M135.431 241.169C145.465 243.569 128.468 254.034 125.964 257.78C101.31 279.273 78.4121 302.458 55.0711 324.771C21.3859 329.093 124.68 235.233 135.431 241.169Z",
				fill: "#79C912",
				fillOpacity: .1
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M472.606 393.093C466.621 411.098 425.706 406.832 410.851 401.851C401.441 400.248 368.202 373.918 387.742 368.988C417.977 389.668 436.995 390.542 472.606 393.093Z",
				fill: "#79C912",
				fillOpacity: .1
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M427.03 448.869C416.179 449.208 362.458 436.87 377.418 420.641C393.981 426.16 410.974 436.652 430.031 434.024C444.068 435.075 458.174 426.661 471.737 429.618C484.851 445.455 436.692 447.729 427.03 448.869Z",
				fill: "#79C912",
				fillOpacity: .1
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M343.897 528.071C342.087 527.261 341.094 527.03 342.234 525.575C364.517 510.881 389.235 500.823 414.113 491.505C426.617 490.452 474.577 451.841 477.428 470.477C476.22 479.461 462.594 477.914 456.294 482.368C420.723 501.557 381.403 513.403 343.897 528.071Z",
				fill: "#79C912",
				fillOpacity: .1
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M237.299 373.192C284.4 371.024 303.16 419.543 274.355 402.567C249.484 369.809 214.82 393.775 193.672 383.386C201.044 372.989 222.655 374.73 237.299 373.192Z",
				fill: "#79C912",
				fillOpacity: .1
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M357.029 497.77C350.728 494.266 355.206 481.516 348.01 479.714C342.748 480.003 321.204 481.498 332.662 472.12C345.576 468.55 351.172 470.051 348.09 454.289C346.285 447.745 352.795 440.114 357.158 448.296C358.89 453.116 359.317 458.459 360.773 463.308C366.481 469.755 377.136 462.034 384.45 465.015C383.796 475.918 364.224 473.182 362.891 481.083C363.084 487.085 365.215 496.36 357.029 497.77Z",
				fill: "#79C912",
				fillOpacity: .1
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M134.376 43.9374C124.856 35.3936 152.109 28.8244 157.456 25.0504C174.086 17.86 190.781 10.8234 207.451 3.7313C209.128 2.89169 212.993 1.58547 213.51 4.00534C215.974 9.2173 217.886 12.7105 210.507 15.262C185.608 26.0688 160.314 35.8617 134.376 43.9374Z",
				fill: "#79C912",
				fillOpacity: .1
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M95.8712 227.165C92.1616 240.76 63.6037 209.522 57.9071 204.851C52.8222 200.676 50.7982 195.618 57.1067 191.41C68.1182 180.028 94.7545 216.753 95.8712 227.165Z",
				fill: "#79C912",
				fillOpacity: .1
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M107.992 318.717C86.4859 317.435 147.97 266.571 153.725 277.578C142.53 293.249 126.979 313.537 107.992 318.717Z",
				fill: "#79C912",
				fillOpacity: .1
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M256.346 415.651C255.692 421.922 252.025 426.544 246.694 420.735C236.214 409.965 220.67 413.268 207.251 411.066C191.316 395.276 254.941 395.963 256.346 415.651Z",
				fill: "#79C912",
				fillOpacity: .1
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M51.6238 258.59C41.7326 256.699 9.03651 235.393 23.9458 224.367C37.2732 227.292 46.8494 243.34 58.3801 251.199C64.3182 255.751 57.9596 259.779 51.6238 258.59Z",
				fill: "#79C912",
				fillOpacity: .1
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M346.218 369.383C345.114 368.921 344.437 368.637 343.759 368.354C342.181 371.055 344.552 372.245 346.218 369.383ZM346.967 358.073C368.397 356.322 355.567 387.876 339.867 382.04C323.678 378.134 333.388 356.282 346.967 358.073Z",
				fill: "#79C912",
				fillOpacity: .1
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M181.274 140.22C178.525 152.987 144.963 119.585 140.941 114.112C135.092 106.867 141.198 102.427 147.129 109.454C156.74 121.228 173.505 127.654 181.274 140.22Z",
				fill: "#79C912",
				fillOpacity: .1
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M5.32069 256.047C15.8965 263.136 26.3796 274.453 31.1308 286.208C20.1705 288.349 -14.1637 265.434 5.32069 256.047Z",
				fill: "#79C912",
				fillOpacity: .1
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M174.747 74.8877C167.468 75.4914 165.428 68.7367 172.846 66.683C186.794 63.5299 201.956 52.8778 215.71 54.4167C210.061 67.1134 187.482 71.1765 174.747 74.8877Z",
				fill: "#79C912",
				fillOpacity: .1
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M239.629 447.032C239.297 450.415 236.736 452.65 234.041 449.246C229.58 444.442 223.075 443.322 217.754 439.899C212.279 425.741 242.454 436.179 239.629 447.032Z",
				fill: "#79C912",
				fillOpacity: .1
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M194.063 115.928C189.93 116.998 177.837 113.942 183.4 108.687C190.302 105.997 199.532 105.724 206.271 108.991C211.433 115.606 198.161 115.944 194.08 116.247C194.074 116.14 194.069 116.034 194.063 115.928Z",
				fill: "#79C912",
				fillOpacity: .1
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M163.366 329.752C158.069 336.889 149.477 328.612 151.191 321.616C156.999 311.203 163.108 322.135 163.366 329.752Z",
				fill: "#79C912",
				fillOpacity: .1
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M320.995 238.443C351.699 239.267 349.026 215.565 334.222 196.742C323.682 188.499 308.418 192.417 297.735 198.61C289.51 203.11 287.938 211.884 290.148 220.505C293.293 235.429 307.363 238.49 320.995 238.443ZM317.617 250.915C246.819 253.019 259.505 165.93 326.99 178C370.56 191.697 369.702 256.255 317.617 250.915Z",
				fill: "#79C912",
				fillOpacity: .1
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M314.405 225.568C291.258 223.312 308.687 191.719 323.954 204.804C337.633 212.15 328.626 227.56 314.405 225.568Z",
				fill: "#79C912",
				fillOpacity: .1
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M136.81 136.219C157.653 143.059 155.598 157.901 136.608 142.676C134.887 140.44 134.325 138.411 136.81 136.219Z",
				fill: "#79C912",
				fillOpacity: .1
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M128.611 158.588C125.693 161.617 119.972 157.376 118.033 154.522C119.321 146.22 127.065 154.768 128.611 158.588Z",
				fill: "#79C912",
				fillOpacity: .1
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_8150_8484",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 616,
			height: 530,
			fill: "white"
		})
	}) })]
});
export default SvgBg2;
